export default "<div>\r\n    <app-person-icon></app-person-icon>\r\n</div>";